export const LOCAL_STORAGE_TICKETS_DAILY_LIMIT = 'tournamentTicketsDailyLimit';
